import { dialog, InputFactory } from "../../../../nq-component";
import React, { useState } from "react";

function DialogHired({ handleSubmit }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [employmentStatus, setStatus] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  function _handleAssign() {
    handleSubmit(startDate, endDate, employmentStatus);
  }

  return (
    <>
      <form onSubmit={() => _handleAssign()}>
        <div className="p-4">
          <div className="d-flex flex-column">
            <div className="d-flex gap-3">
              <i
                class="bi bi-briefcase fs-2 px-2 py-1 rounded"
                style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
              ></i>
              <h5
                className="fw-bold align-self-center"
                style={{ color: "#D18237" }}
              >
                Hire Applicant
              </h5>
            </div>
            <div className="d-flex flex-column mx-5 mt-4">
              <div className="">
                <div className="mb-3">
                  <p className="m-0">Hired Date</p>
                  <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="col-12 px-3 py-2 border rounded"
                    required
                  />
                </div>

                <div className="mb-3">
                  <p className="m-0">Effectivity Date</p>
                  <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="col-12 px-3 py-2 border rounded"
                    required
                  />
                </div>

                <div className="mb-3">
                  <p className="m-0">Employment Status</p>
                  <InputFactory
                    type="Enum"
                    required="true"
                    options={["Regular", "Probationary"]}
                    onChange={(value) => setStatus(value)}
                    className="m-0"
                    placeholder="Select Employment Status"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mb-3">
          <>
            <>
              <button
                className="btn"
                style={{ backgroundColor: "#e8ecf3" }}
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn text-white ms-2"
                style={{ backgroundColor: "#D18237" }}
                // onClick={() => _handleAssign()}
              >
                Confirm
              </button>
            </>
          </>
        </div>
      </form>
    </>
  );
}

export default DialogHired;
